import React from 'react';
import PropTypes from 'prop-types';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import Tooltip from '@mui/material/Tooltip';
import { Box, styled } from '@mui/material';
import { Slider } from '@totalsoft/rocket-ui';
import { SliderWrapper } from '../CommonStyles';

const StyledPriorityHighIcon = styled(PriorityHighIcon)(({ theme }) => ({
  position: 'absolute',
  left: theme.spacing(-3.5),
  top: theme.spacing(2)
}));

const DetailedSlider = ({ defaultValue, value, auxiliaryInfo, error, ...rest }) => {
  return (
    <Box sx={{ position: 'relative' }}>
      {defaultValue !== null
        ? value !== defaultValue && (
            <Tooltip title={auxiliaryInfo}>
              <StyledPriorityHighIcon color={error ? 'error' : 'primary'} />
            </Tooltip>
          )
        : ''}
      <SliderWrapper>
        <Slider value={value} defaultValue={defaultValue} error={error} {...rest} />
      </SliderWrapper>
    </Box>
  );
};

DetailedSlider.propTypes = {
  defaultValue: PropTypes.number,
  value: PropTypes.number,
  error: PropTypes.bool.isRequired,
  auxiliaryInfo: PropTypes.string
};

export default DetailedSlider;
